module.exports = __webpack_public_path__ + "static/img/processed.cb3b5553.svg";